import { render, staticRenderFns } from "./TermsOfServicesForPickupAtConvenientStore.pug?vue&type=template&id=7a2572ae&lang=pug&"
import script from "./TermsOfServicesForPickupAtConvenientStore.vue?vue&type=script&lang=js&"
export * from "./TermsOfServicesForPickupAtConvenientStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports